export const defaultStyle = {
  footerlinsMob:
    "footer block bg-darkBlue w-full text-white lg:text-20 text-center py-35 lg:py-[23px] mt-40 lg:mt-0 print-noshow",
  FooterHead:
    "lg:pb-25 py-25 lg:py-auto lg:w-3/4 md:w-[42%] w-[87%] mx-auto lg:leading-6 lg:w-full lg:text-xl	md:text-[20px] text-lg footText lg:child:inline",
  footerWrap: "",
  fatFooter: "",
  footerDesc: "text-black pb-[1rem] font-LatoSan",
  footerParts : "",
  FooterWrapper : "w-full bg-purple",
  footerMain : "footerMain md:max-w-[1260px] xxl:max-w-[1280px] mx-auto w-full px-[38px] pt-[5px] pb-[30px] sm:pt-[25px] sm:pt-[60px] md:py-[22px] md:px-[30px] mx-auto text-[16px] leading-[1.5] text-white font-Lato",
  FooterDiv : "relative md:after:border-r-4 md:after:border-[#ffa500] md:after:content-[''] md:after:h-[200px] md:after:absolute md:after:top-0 md:after:right-[-15px]",
  copyrightContainer: "lg:text-[12px] text-base text-white text-center py-10 md:leading-[1.05rem] leading-[22.4px] lg:child:inline child:block",
  footerLogotext : "footerlogo-text hidden lg:block text-left",
  footerLogotextMobile: "max-w-[240px] lg:hidden mt-[22px] mb-[10px] text-center",
  footerLogo : "mx-auto  lg:mx-0",
  footerImg:"mx-auto w-[75%] md:w-auto",
  footerNavs : "footerNavs",
  FooterCopyright : "xl:text-left lg:mt-0 lg:mb-[43px] xl:mb-0 -order-1 lg:order-0 text-center FooterCopyright lg:w-[574px] lg:ml-[14px]",
  footerCookieLinks:"footerCookieLinks lg:order-1 w-full flex flex-col items-center lg:items-end lg:flex-row justify-center lg:justify-end gap-[22px] lg:gap-[60px] xl:justify-end items-end",
  footercopyLinkGrp: "flex justify-center lg:justify-between flex-wrap lg:flex-nowrap",
  footersingleLink: "text-white underline hover:text-white hover:no-underline"
}

export const LOGO = {
  className: "p-2 white mx-auto",
  fatFooter: "",
  footerDesc: "mt-[12px] text-center lg:text-left lg:ml-[14px]",
  footerParts : "flex flex-col-reverse [&>a]:block lg:[&>a]:inline-block",
  FooterWrapper : "w-full bg-antiFlashWhite bg-purple",
  footerMain : "footerMain md:max-w-[1260px] xxl:max-w-[1280px] mx-auto w-full px-[38px] pt-[5px] pb-[30px] sm:pt-[25px] sm:pt-[60px] md:py-[22px] md:px-[30px] mx-auto text-[16px] leading-[1.5] text-white font-Lato",
  FooterDiv : "footerDiv relative w-full lg:max-w-[574px]",
  copyrightContainer: "lg:text-[12px] text-base text-white text-center py-10 md:leading-[1.05rem] leading-[22.4px] lg:child:inline child:block",
  footerLogotext : "",
  footerLogo : "mx-auto",
  footerImg:"w-[268px] h-[151px] max-[1023px]:mx-auto",
  footerNavs : "hidden",
  FooterCopyright : "xl:text-left mt-[43px] lg:mt-0 lg:mb-[43px] xl:mb-0 text-center FooterCopyright lg:w-[574px] lg:ml-[14px]",
  footerCookieLinks:"footerCookieLinks lg:order-1 w-full flex flex-col items-center lg:items-end lg:flex-row justify-center lg:justify-end gap-[22px] lg:gap-[60px] xl:justify-end items-end",
}

export const ENG_FOOTER_NEW = {
  ...defaultStyle,
    footerlinsMob:
    "footer block bg-darkBlue w-full text-white lg:text-20 text-center py-35 lg:py-[23px] mt-40 lg:mt-0 print-noshow",
  FooterHead:
    "lg:pb-25 py-25 lg:py-auto lg:w-3/4 md:w-[42%] w-[87%] mx-auto lg:leading-6 lg:w-full lg:text-xl	md:text-[20px] text-lg footText lg:child:inline",
  footerWrap: "",
  fatFooter: "",
  footerDesc: "mt-[12px] text-center lg:text-left lg:ml-[14px]",
  footerParts : "flex flex-col-reverse [&>a]:block lg:[&>a]:inline-block",
  FooterWrapper : "w-full bg-purple",
  footerMain : "footerMain md:max-w-[1260px] xxl:max-w-[1280px] mx-auto w-full px-[38px] pt-[5px] pb-[30px] sm:pt-[25px] sm:pt-[60px] md:py-[22px] md:px-[30px] mx-auto text-[16px] leading-[1.5] text-white font-Lato",
  FooterDiv : "footerDiv relative w-full lg:max-w-[574px]",
  copyrightContainer: "lg:text-[12px] text-base text-white text-center py-10 md:leading-[1.05rem] leading-[22.4px] lg:child:inline child:block",
  footerLogo : "mx-auto lg:mx-0",
  footerImg:"w-[268px] h-[151px] max-[1023px]:mx-auto",
  footerNavs : "hidden",
  FooterCopyright : "xl:text-left lg:mt-0 lg:mb-[43px] xl:mb-0 -order-1 lg:order-0 text-center FooterCopyright lg:w-[574px] lg:ml-[14px]",
  footerCookieLinks:"footerCookieLinks lg:order-1 w-full flex flex-col items-center lg:items-end lg:flex-row justify-center lg:justify-end gap-[22px] lg:gap-[60px] xl:justify-end items-end",
  footersingleLink: "text-white underline hover:text-white hover:no-underline"
}
